module.exports = "/assets/28aa88fad265bbd89296632661ef07ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/M5.png
// module id = 1602
// module chunks = 0